import { apiBase, cdnUrl, botId, callbackURL, environment, apiBaseUrl } from "../conf.json";
import RESTManager from "./rest/RESTManager";
import vueSelect from "vue-select";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import Vue from "vue";
import axios from "axios";

Vue.config.productionTip = false;

Vue.prototype.$apiBase = apiBase;
Vue.prototype.$axios = axios;
Vue.prototype.$cdnUrl = cdnUrl;
Vue.prototype.$botId = botId;
Vue.prototype.$callbackURL = callbackURL;
Vue.prototype.$environment = environment;
Vue.prototype.$rest = new RESTManager(Vue, {
  http: {
    api: apiBaseUrl,
    version: 2
  },
  tokenPrefix: "Bearer",
  restSweepInterval: 20,
  retryLimit: 25,
  restRequestTimeout: 15000
});

window.$rest = Vue.prototype.$rest;

Vue.component("v-select", vueSelect);
new Vue({ router, store, render: fun => fun(App) }).$mount("#app");
